import { useEffect, useState } from 'react';
import newApi from 'configs/new-api';
import { isRole } from 'utils/UserUtils';
import { Role } from 'models/role';

export function useProposal() {
  const [agreements, setAgreements] = useState([]);
  const [operations, setOperations] = useState([]);
  const [banks, setBanks] = useState([]);
  const [liberationFonts, setLiberationFonts] = useState([]);
  const [benefits, setBenefits] = useState([]);
  const [users, setUsers] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [flags, setFlags] = useState([]);
  const [filteredFlags, setFilteredFlags] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [
          { data: statusData },
          { data: flagData },
          { data: agreementData },
          { data: operationData },
          { data: bankData },
          { data: liberationFontData },
          { data: benefitData },
          { data: userData },
        ] = await Promise.all([
          newApi.get('/proposal-status'),
          newApi.get('/proposal-flag'),
          newApi.get('/agreement'),
          newApi.get('/operation'),
          newApi.get('/bank'),
          newApi.get('/liberation-font'),
          newApi.get('/benefit'),
          newApi.get('/user/only-active'),
        ]);

        setStatuses(statusData);
        setFlags(flagData);
        setAgreements(agreementData);
        setOperations(operationData);
        setBanks(bankData);
        setLiberationFonts(liberationFontData);
        setBenefits(benefitData);
        setUsers(userData);

        // filtro de flags baseado na role
        const allowed = flagData.filter(({ roles }) =>
          roles?.some((role) => isRole(Role[role]))
        );
        setFilteredFlags(allowed);
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);
  const [data, setData] = useState({
    proposal: {
      id: '',
      // The rest of fields
    },
    customer: {
      id: '',
      // Bank data
      bank: {},
      // The rest of fields
    },
    attachments: {
      notes: '',
      files: [],
    },
  });

  const resetDataToManage = () => {
    console.log('reseting');
    setDataToManage({
      proposal: {
        id: '',
      },
      customer: {
        id: '',
        bank: {},
      },
      attachments: {
        notes: '',
        files: [],
      },
    });
  };

  const setDataToManage = ({ customer, bank, proposal, attachments }) => {
    setData({
      proposal: {
        ...proposal,
      },
      customer: {
        ...customer,
        bank: {
          ...bank,
        },
      },
      attachments,
    });
  };

  return {
    dataToManage: data,
    setDataToManage,
    resetDataToManage,
    agreements,
    operations,
    banks,
    benefits,
    liberationFonts,
    users,
    statuses,
    flags,
    filteredFlags,
  };
}
